import { AbstractTagClass } from 'tag/ts/tag/abstract/AbstractTagClass';
export class AviaPlugin extends AbstractTagClass {
    package;
    constructor(argument) {
        super(argument);
    }
    get namespaceBase() {
        return this.tag?.model?.config?.tag?.Imports?.params?.avia;
    }
    namespaceKey = 'plugin_avia';
    get namespaceComplete() {
        return this.namespaceBase?.[this.namespaceKey]?.namespace;
    }
    get loadedPlugin() {
        return this.getPluginIfAlreadyLoaded(this.namespaceComplete);
    }
    shouldBeUsed() {
        return true;
    }
    getFactoryParams() {
        this?.logger?.log('getFactoryParams base');
        return {
            debug: this.runtimeVO?.debug?.player
        };
    }
    getPluginIfAlreadyLoaded(namespace) {
        if (this.utils.Type.isEmpty(namespace)) {
            return undefined;
        }
        if (this.utils.Type.isString(namespace)) {
            const nsObject = this.utils.DOM.getDeepVal(window, namespace);
            switch (this.utils.Type.isNullOrUndefined(nsObject)) {
                case true:
                    return undefined;
                case false:
                    return nsObject['plugin'];
            }
        }
    }
    generateConfig() {
        const factory = this.getConfigFactory();
        if (this.utils.Type.isNullOrUndefined(factory)) {
            this?.logger?.warn('Could not get plugin factory');
            return undefined;
        }
        const initialized = factory(this.getFactoryParams());
        return initialized;
    }
    getConfigFactory() {
        this?.logger?.log('getConfigFactory', this);
        let pluginConfig = undefined;
        const loadedPlugin = this.loadedPlugin;
        this?.logger?.log('loadedPlugin', loadedPlugin);
        if (!this.utils.Type.isNullOrUndefined(loadedPlugin)) {
            this?.logger?.log('getConfig', 'loadedPlugin:', loadedPlugin);
            pluginConfig = loadedPlugin;
        }
        else if (!this.utils.Type.isNullOrUndefined(this.package)) {
            this?.logger?.log('getConfig', 'this.package:', this.package);
            pluginConfig = this.package;
        }
        if (this.utils.Type.isNullOrUndefined(pluginConfig)) {
            this?.logger?.warn('Plugin was neither imported nor loaded', this.namespaceComplete, this.package);
        }
        return pluginConfig;
    }
}
